import e from "../_virtual/_rolldown_dynamic_import_helper.mjs";
import { utilizeLocalizedCountries as t } from "@systemeio/util";
//#region src/i18n/loaders.ts
var n = async (n, r) => {
	let i = await e(/* #__PURE__ */ Object.assign({
		"../locales/ar/common.json": () => import("../locales/ar/common.json.mjs"),
		"../locales/cs/common.json": () => import("../locales/cs/common.json.mjs"),
		"../locales/da/common.json": () => import("../locales/da/common.json.mjs"),
		"../locales/de/common.json": () => import("../locales/de/common.json.mjs"),
		"../locales/el/common.json": () => import("../locales/el/common.json.mjs"),
		"../locales/en/common.json": () => import("../locales/en/common.json.mjs"),
		"../locales/es/common.json": () => import("../locales/es/common.json.mjs"),
		"../locales/fr/common.json": () => import("../locales/fr/common.json.mjs"),
		"../locales/hi/common.json": () => import("../locales/hi/common.json.mjs"),
		"../locales/hu/common.json": () => import("../locales/hu/common.json.mjs"),
		"../locales/id/common.json": () => import("../locales/id/common.json.mjs"),
		"../locales/it/common.json": () => import("../locales/it/common.json.mjs"),
		"../locales/ja/common.json": () => import("../locales/ja/common.json.mjs"),
		"../locales/nl/common.json": () => import("../locales/nl/common.json.mjs"),
		"../locales/no/common.json": () => import("../locales/no/common.json.mjs"),
		"../locales/pl/common.json": () => import("../locales/pl/common.json.mjs"),
		"../locales/pt/common.json": () => import("../locales/pt/common.json.mjs"),
		"../locales/ro/common.json": () => import("../locales/ro/common.json.mjs"),
		"../locales/ru/common.json": () => import("../locales/ru/common.json.mjs"),
		"../locales/sk/common.json": () => import("../locales/sk/common.json.mjs"),
		"../locales/sl/common.json": () => import("../locales/sl/common.json.mjs"),
		"../locales/sq/common.json": () => import("../locales/sq/common.json.mjs"),
		"../locales/sr/common.json": () => import("../locales/sr/common.json.mjs"),
		"../locales/sv/common.json": () => import("../locales/sv/common.json.mjs"),
		"../locales/th/common.json": () => import("../locales/th/common.json.mjs"),
		"../locales/tr/common.json": () => import("../locales/tr/common.json.mjs"),
		"../locales/uk/common.json": () => import("../locales/uk/common.json.mjs"),
		"../locales/zh/common.json": () => import("../locales/zh/common.json.mjs")
	}), `../locales/${n}/${r}.json`, 4).then((e) => e.default), a = (await t(n))?.countries;
	return {
		...i,
		countries: a
	};
};
//#endregion
export { n as loadLangBundle };
